import { useReducer, useEffect } from 'react'
import {
    Toolbar,
    IconButton,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material'

import { Menu as MenuIcon } from '@mui/icons-material'
import NavMenuAvatar from './NavMenuAvatar'

import { useMinimizer } from '../../context/MinimizeContext'
import { useQuickStartWizard } from '../../context/QuickStartWizard'
import { useAuth } from '../../context/AuthenticationContext'
import { getManufacturers } from '../../apiRoutes'
import { useGlobalState } from '../../context/GlobalStateContext'

const NavMenuToolbar = ({ handleDrawerToggle }) => {
    const { minimizedModals, setMinimized } = useMinimizer()
    const { setQuickStartWizard } = useQuickStartWizard()
    const { auth } = useAuth()
    // const { userProfile } = auth
    // const { superAdmin, userProfileAssignedManufacturers } = userProfile
    // const { activeManufacturer } = auth

    const { globalState, setUser } = useGlobalState()
    const { oupUser } = globalState
    // Users without a profile/active manufacturer (e.g. a freshly registered
    // customer) leave these undefined; guard so the toolbar doesn't crash the
    // whole app to a blank screen.
    const { userProfile, activeManufacturer } = oupUser || {}
    const { superAdmin, userProfileAssignedManufacturers } = userProfile || {}
    const { manufacturerName } = activeManufacturer || {}

    const defaultState = {
        manufacturers: [],
        manufacturerOptions: [],
    }

    const reducer = (state, newState) => ({ ...state, ...newState })
    const [state, setState] = useReducer(reducer, defaultState)
    const { manufacturers, manufacturerOptions } = state

    const getData = async () => {
        let manufacturers: any = []
        let manufacturerOptions: any = []
        if (superAdmin && superAdmin === true) {
            const getManufacturerData = await getManufacturers(true)
            if (getManufacturerData?.length !== 0) {
                manufacturers = getManufacturerData
                manufacturerOptions = getManufacturerData?.map(
                    ({ manufacturerName }) => manufacturerName
                )
            }
        } else {
            manufacturerOptions =
                userProfileAssignedManufacturers?.length !== 0 &&
                userProfileAssignedManufacturers?.map(
                    ({ manufacturerName }) => manufacturerName
                )

            manufacturers = userProfileAssignedManufacturers
        }

        setState({
            manufacturerOptions,
            manufacturers,
        })
    }

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        getData()
    }, [userProfileAssignedManufacturers])

    return (
        <Toolbar className="navigation-menu-toolbar-background" sx={{ gap: 1 }}>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 0.5, display: { sm: 'none' } }}
            >
                <MenuIcon />
            </IconButton>

            {manufacturers?.length > 1 && (
                <FormControl
                    size="small"
                    sx={{ width: { xs: 180, sm: 240, md: 280 } }}
                >
                    <InputLabel
                        id="activeManufacturer-label"
                        sx={{
                            color: 'rgba(255,255,255,0.7)',
                            '&.Mui-focused': { color: 'rgba(255,255,255,0.9)' },
                        }}
                    >
                        Active Manufacturer
                    </InputLabel>
                    <Select
                        labelId="activeManufacturer-label"
                        id="activeManufacturer"
                        label="Active Manufacturer"
                        value={manufacturerName || ''}
                        onChange={(e) => {
                            const value = e.target.value
                            const getFullManufacturer = manufacturers.find(
                                ({ manufacturerName }: any) =>
                                    manufacturerName === value
                            )
                            setUser({
                                key: 'activeManufacturer',
                                value: getFullManufacturer,
                            })
                        }}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 360 } } }}
                        sx={{
                            color: '#fff',
                            backgroundColor: 'rgba(0,0,0,0.28)',
                            borderRadius: 1.5,
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgba(255,255,255,0.18)',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgba(255,255,255,0.35)',
                            },
                            '& .MuiSvgIcon-root': {
                                color: 'rgba(255,255,255,0.7)',
                            },
                        }}
                    >
                        {(manufacturerOptions || []).map((opt: string) => (
                            <MenuItem key={opt} value={opt}>
                                {opt}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}

            <Box sx={{ flexGrow: 1 }} />

            <NavMenuAvatar />
        </Toolbar>
    )
}

export default NavMenuToolbar
